import { breakpoints } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const OnThisPageOuter = styled.div`
    padding-top: 16px;
    margin-bottom: 48px;

    ${breakpoints.large} {
        padding-top: 0;
    }
`;

export const List = styled.ul`
    margin: 24px 0 0;
    padding: 0 0 0 20px;
    border-left: 3px solid ${colors.brandMid};

    li {
        display: block;
        margin: 16px 0;

        a {
            display: inline-block;
            text-decoration: none;
            color: ${colors.brandMid};
            font-weight: 500;

            [data-whatintent="mouse"] &:hover {
                color: ${colors.brandMid};
                box-shadow: inset 0 0px 0 white,
                    inset 0 -2px 0 ${transparentize(0.5, colors.brandMid)};
            }
        }
    }
`;
